import { PageHeader } from '@celltrak/ui-components';

const ResolutionHeader = () => (
  <header>
    <PageHeader title="Resolution Codes" />
  </header>
);

export default ResolutionHeader;
